module.exports = __webpack_public_path__ + "static/media/signage-indoor-img20.74d4c8fe.jpg";